Object.defineProperty(exports, '__esModule', { value: true });

var text_component = require('./text/component.js');
var title_index = require('./title/index.js');
var titleMobile_component = require('./title-mobile/component.js');
var titleResponsive_component = require('./title-responsive/component.js');

var Typography = {
    Title: title_index.Title,
    Text: text_component.Text,
    TitleResponsive: titleResponsive_component.TitleResponsive,
    TitleMobile: titleMobile_component.TitleMobile,
};

exports.Typography = Typography;
